import { Button, Grid, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import uuidv4 from 'src/utils/uuidv4';
import ButtonComponent from './Button';
import { useStyles } from 'src/careflow/helpers/workflowStyle';

const ConfirmComponent = (props: any) => {
  const {
    record,
    checklistItem,
    handler
  } = props?.others;

  const [ showConfirm, setShowConfirm ] = useState(false);
  
  const items = checklistItem && checklistItem?.metadata ? JSON.parse(checklistItem?.metadata) : {};
  const { question = null, response = null } = items?.ui?.data;
  const classes: any = useStyles({});

  return (
    showConfirm ? 
      <Grid container justifyContent="center" alignItems="center" direction="column">
        <Grid item>
          <Typography sx={{ fontSize: 12, textAlign: 'center' }}>
            {question}
          </Typography>
        </Grid>
        <Grid item>
          <Stack direction="row" alignItems="center" spacing={2} mt={1}>
            {response?.map((item) => {
              const { buttonTitle, resourceRelated, status, className } = item;
              const response = `${question}: ${buttonTitle}`;
              return (
                <Button
                  key={uuidv4()}
                  variant="contained"
                  type="submit"
                  size="small"
                  className={className && classes?.[className]}
                  onClick={() =>
                    handler({
                      record,
                      checklistItem,
                      more: { resourceRelated, status, response },
                    })
                  }
                >
                  {buttonTitle}
                </Button>
              );
            })}
          </Stack>
        </Grid>
      </Grid> : 
      <ButtonComponent
        elementName={props?.elementName}
        id={props?.id}
        type={props?.type}
        others= {{
          record,
          checklistItem,
          handler: () => setShowConfirm(true),
        }}
      />
  );
};

export default ConfirmComponent;